<template>
  <!-- ===== 语言选择下拉框 ===== -->
  <div
    class="lang-dropdown"
    @mouseenter="openLangDropdown"
    @mouseleave="closeLangDropdown"
  >
    <div class="lang-selector">
      <span class="lang-flag-circle">
        <img :src="currentLangFlag" alt="" />
      </span>
      <span class="lang-name">{{ currentLangAbbr }}</span>

      <svg
        class="lang-arrow"
        viewBox="0 0 24 24"
        width="14"
        height="14"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </div>
    <!-- 下拉菜单 -->
    <transition name="fade">
      <div
        v-show="isLangDropdownOpen"
        class="dropdown-menu lang-dropdown-menu"
        style=""
      >
        <ul class="dropdown-list">
          <li
            v-for="lang in languages"
            :key="lang.code"
            @click="switchLanguage(lang.code)"
            style="margin-bottom: 1px"
          >
            <a
              href="javascript:;"
              :class="{ active: currentLang === lang.code }"
            >
              <span class="lang-flag-circle">
                <img :src="lang.flag" alt="" />
              </span>
              <span class="lang-name-item">{{ lang.abbr }}</span>
              <span v-if="currentLang === lang.code" class="lang-check">✓</span>
            </a>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import consts from "@/utils/consts";
import { setLanguage } from "@/locales";
export default {
  name: "LangSwitcher",
  data() {
    return {
      // 语言下拉控制
      isLangDropdownOpen: false,
      // 当前语言
      currentLang: "zh-hans",
      // 语言列表（9 个国家：圆圈国旗 + 国家简称）
      languages: [
        {
          code: "en-us",
          name: "美国",
          flag: require("@/assets/lang/us.webp"),
          abbr: "English (US)",
        },

        {
          code: "ja-jp",
          name: "日本",
          flag: require("@/assets/lang/jp.webp"),
          abbr: "日本語",
        },
        {
          code: "ko-kr",
          name: "韩国",
          flag: require("@/assets/lang/ko.webp"),
          abbr: "한국어",
        },
        {
          code: "de-de",
          name: "德国",
          flag: require("@/assets/lang/de.webp"),
          abbr: "Deutsch",
        },
        {
          code: "en-gb",
          name: "英国",
          flag: require("@/assets/lang/ge.webp"),
          abbr: "English (UK)",
        },
        {
          code: "fr-fr",
          name: "法国",
          flag: require("@/assets/lang/fr.webp"),
          abbr: "Français",
        },
        {
          code: "ar-ae",
          name: "阿联酋",
          flag: require("@/assets/lang/ae.webp"),
          abbr: "العربية",
        },
        {
          code: "en-sg",
          name: "新加坡",
          flag: require("@/assets/lang/sg.webp"),
          abbr: "English (SG)",
        },
        {
          code: "zh-hant",
          name: "中国",
          flag: require("@/assets/lang/cn.webp"),
          abbr: "繁體中文", // ✅ 改成繁体中文
        },
      ],
    };
  },
  computed: {
    // 当前语言名称
    currentLangName() {
      const lang = this.languages.find((l) => l.code === this.currentLang);
      return lang ? lang.name : "中国";
    },
    // 当前语言旗帜（图片路径）
    currentLangFlag() {
      const lang = this.languages.find((l) => l.code === this.currentLang);
      return lang ? lang.flag : require("@/assets/lang/cn.webp");
    },
    // 当前语言简称
    currentLangAbbr() {
      const lang = this.languages.find((l) => l.code === this.currentLang);
      return lang ? lang.abbr : "CHN";
    },
  },
  created() {
    // 从 localStorage 获取语言设置
    const savedLang = localStorage.getItem(consts.KEY_LANG);
    const lang = JSON.parse(savedLang);
    if (lang) {
      this.currentLang = lang.lang;
    }
  },
  methods: {
    // ===== 语言下拉控制 =====
    openLangDropdown() {
      this.isLangDropdownOpen = true;
    },
    closeLangDropdown() {
      this.isLangDropdownOpen = false;
    },
    // ===== 切换语言 =====
    switchLanguage(code) {
      console.log("code", code);
      this.currentLang = code;
      const lang = { text: this.currentLangName, lang: code };
      // localStorage.setItem(consts.KEY_LANG, JSON.stringify(lang));
      // // 切换 i18n 语言
      // this.$i18n.locale = code;
      // // 关闭下拉
      this.isLangDropdownOpen = false;
      // // 触发页面刷新或重新渲染
      this.$emit("language-changed", code);

      // 设置语言
      setLanguage(lang);
    },
  },
};
</script>

<style scoped>
/* ===== 语言选择器 ===== */
.lang-dropdown {
  position: relative;
  cursor: pointer;
}

.lang-selector {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0px 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
  color: rgba(255, 255, 255, 0.7);
}
.lang-selector:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.12);
  color: #fff;
}

/* 圆圈国旗 */
.lang-flag-circle {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
}

.lang-flag-circle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.lang-name {
  font-size: 17px;
  font-weight: 500;
}

.lang-arrow {
  transition: transform 0.3s ease;
  opacity: 0.5;
}
.lang-dropdown:hover .lang-arrow {
  transform: rotate(180deg);
  opacity: 0.8;
}

/* ===== 下拉菜单 ===== */
.dropdown-menu {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  min-width: 260px;
  background: #1a1a2e;
  backdrop-filter: blur(24px);
  background: rgba(20, 20, 35, 0.95);
  border-radius: 16px;
  padding: 12px 0;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transform-origin: top right;
}

/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.96) translateY(-8px);
}

/* ===== 语言下拉菜单 ===== */
.lang-dropdown-menu {
  min-width: 200px;
  max-height: 360px;
  overflow-y: auto;
}

.dropdown-list {
  list-style: none;
  padding: 4px 0;
  margin: 0;
}

.dropdown-list li {
  padding: 0 8px;
}

.lang-dropdown-menu .dropdown-list li a {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  font-size: 14px;
  transition: all 0.15s ease;
}

.lang-dropdown-menu .dropdown-list li a:hover {
  background: rgba(0, 180, 255, 0.12);
  color: #fff;
}

.lang-dropdown-menu .dropdown-list li a.active {
  background: rgba(0, 180, 255, 0.15);
  color: #00b4ff;
}

.lang-name-item {
  flex: 1;
  font-weight: 450;
}

.lang-check {
  color: #00b4ff;
  font-weight: 700;
  font-size: 14px;
}

/* 滚动条美化 */
.lang-dropdown-menu::-webkit-scrollbar {
  width: 4px;
}
.lang-dropdown-menu::-webkit-scrollbar-track {
  background: transparent;
}
.lang-dropdown-menu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}
.lang-dropdown-menu::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.25);
}
</style>
